import classNames from 'clsx'
import { bool, number } from 'prop-types'

import Price from 'views/components/atoms/Price'

import './PriceOld.scss'

const PriceOld = ({
  amount,
  currency,
  symbolRight,
  inheritColor,
  noLineThrough,
  superScript,
}) => {
  const classname = classNames('a-PriceOld', {
    'a-PriceOld--color-inherit': inheritColor,
  })
  const classNamePrice = classNames('a-PriceOld--price', {
    'a-PriceOld--no-line-through': noLineThrough,
  })

  return (
    <span className={classname}>
      <span className={classNamePrice}>
        <Price
          amount={amount}
          currency={currency}
          symbolRight={symbolRight}
          dataQa="product-old-price"
        />
      </span>
      {superScript && <sup>{superScript}</sup>}
    </span>
  )
}

PriceOld.propTypes = {
  ...Price.propTypes,
  inheritColor: bool,
  noLineThrough: bool,
  superScript: number,
}

PriceOld.defaultProps = {
  ...Price.defaultProps,
  inheritColor: false,
  noLineThrough: false,
  superScript: null,
}

export default PriceOld
